import axios from 'axios'
import {API_URL} from '../../constants'
import router from './../../router'
const SAVE_CHANGES = 'SAVE_CHANGES'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGOUT = 'LOGOUT'

const state = {
  offer: {
    name: '',
    availableCards: 1,
    offerItem: '',
    pointCollectionTerms: '',
    rewardName: '',
    rewardTerms: '',
    offerMonths: 1,
    offerTimes: 1,
    rewardDays: 1,
    status: 0,
  },
}

// getters
const getters = {
  isLoggedIn: state => {
    return state.isLoggedIn
  },
  getUser: state => {
    return state.user
  },
}

// actions
const actions = {
  save_changes ({ commit, dispatch }, credentials) {
    axios.post(
      `${API_URL}/api/v2/businesses/signup`,
      credentials
    ).then(response => {
      if (response.data.data.token) {
        commit(
          LOGIN_SUCCESS,
          { token: response.data.data.token, user: response.data.data.user }
        )
        router.push({ name: 'Dashboard' })
      }
    }).catch((error) => {
      alert(error.response.data.error)
    })
  },
  logout ({ commit }) {
    localStorage.removeItem('token')
    commit(LOGOUT)
    router.push({ name: 'Login' })
  },
}

// mutations
const mutations = {
  [SAVE_CHANGES] (state) {
    state.pending = true
  },
  [LOGIN_SUCCESS] (state, { token, user }) {
    state.isLoggedIn = true
    state.pending = false
    state.token = token
    state.user = user
    localStorage.setItem('token', token)
    localStorage.setItem('user', JSON.stringify(user))
  },
  [LOGOUT] (state) {
    state.isLoggedIn = false
    state.user = null
    localStorage.removeItem('token')
    state.token = null
    localStorage.removeItem('user')
  },
  [LOGOUT] (state) {
    state.showModal = !state.showModal
  },
  onFieldChange (state, {field, value}) {
    state.offer[field] = value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/offer.js